import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IEntitlementRepository } from '../../repositories/interfaces/iEntitlementRepository';
import InitiatedError from '../../entities/errors/InitiatedError';
import { IQitafVerifyOtpPayload } from '../../../entity/interface/iEntitlements';

export interface IQitafVerifyOtpUseCase {
    execute(
        subType: 'NEW' | 'EXISTING',
        language: string,
        payload: string | IQitafVerifyOtpPayload,
        token?: string | undefined,
        identityToken?: string | undefined
    ): Promise<string>;
}

export class QitafVerifyOtpUseCase implements IQitafVerifyOtpUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get qitafVerifyOtpRepository(): IEntitlementRepository {
        return container.resolve<IEntitlementRepository>(DI.REPOSITORIES.IEntitlementRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        subType: 'NEW' | 'EXISTING',
        language: string,
        payload: string | IQitafVerifyOtpPayload,
        token?: string | undefined,
        identityToken?: string | undefined
    ): Promise<string> {
        const response = await this.qitafVerifyOtpRepository.qitafVerifyOtp(
            subType,
            language,
            payload,
            token,
            identityToken
        );
        if (response.data?.qitafRefId) {
            return response.data.qitafRefId;
        }
        throw new InitiatedError('REF_ID_MISSING', 'Reference ID missing');
    }
}
